// PWA plumbing: service-worker registration, install-prompt capture and the
// "new version available" signal. UI lives in standalone/InstallApp.js.

function notifyUpdate(worker) {
  window.__jigyasaWaitingWorker = worker;
  window.dispatchEvent(new Event("pwa:update-available"));
}

export function registerPWA() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    window.__jigyasaInstallPrompt = e;
    window.dispatchEvent(new Event("pwa:can-install"));
  });
  window.addEventListener("appinstalled", () => {
    window.__jigyasaInstallPrompt = null;
    window.dispatchEvent(new Event("pwa:installed"));
  });

  window.addEventListener("load", async () => {
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      if (reg.waiting && navigator.serviceWorker.controller) notifyUpdate(reg.waiting);
      reg.addEventListener("updatefound", () => {
        const w = reg.installing;
        if (!w) return;
        w.addEventListener("statechange", () => {
          if (w.state === "installed" && navigator.serviceWorker.controller) notifyUpdate(w);
        });
      });
    } catch {
      /* PWA is optional — the site works without it */
    }
  });

  let reloading = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloading) return;
    reloading = true;
    window.location.reload();
  });
}

export function applyUpdate() {
  const w = window.__jigyasaWaitingWorker;
  if (w) w.postMessage({ type: "SKIP_WAITING" });
}
